module.exports = __webpack_public_path__ + "static/media/iStock-1010755712.41a50260.jpg";